import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { Heading, Text } from '@fiverr-private/typography';
import { PlayCircleSolidIcon } from '@fiverr-private/visuals';
import { BriefCreationHowToModal } from '@fiverr-private/dm_brief_creation';
import { CreateBriefButton } from '../../CreateBriefButton';
import { AppI18n } from '../../../i18n';
import EmptyBriefs from '../../../../assets/empty-briefs.gif';

export const NoBriefsState = () => (
  <>
    <Stack gap="14" direction="column" alignItems="center" justifyContent="center" minHeight="60vh">
      <Stack gap="8" direction="column" alignItems="center">
        <img src={EmptyBriefs} alt="empty" width={250} height={188} />
        <Stack gap="2" direction="column" justifyContent="center" alignItems="center">
          <Heading as="h4" textAlign="center">
            <AppI18n k="empty.title" />
          </Heading>
          <Text textAlign="center" maxWidth="450px">
            <AppI18n k="empty.description" />
          </Text>
        </Stack>
      </Stack>
      <Stack gap="2" direction="column" justifyContent="center" alignItems="center">
        <CreateBriefButton title={<AppI18n k="empty.cta" />} />
        <BriefCreationHowToModal>
          <Button variant="ghost">
            <PlayCircleSolidIcon />
            <AppI18n k="empty.how_does_it_work" />
          </Button>
        </BriefCreationHowToModal>
      </Stack>
    </Stack>
  </>
);
